import {CorporationEntity} from "./CorporationEntity";
import {TopicEntity} from "./TopicEntity";
import {SubjectEntity} from "./SubjectEntity";
import {VideoPlaylistVideoEntity} from "./VideoPlaylistVideoEntity";
import {VideoFolderEntity} from "./VideoFolderEntity";
import {VideoEntity} from "./VideoEntity";

export class VideoFolderSubfolderEntity {
  id: number;
  corpId: number;
  videoFolderChildId: number;
  videoFolderParentId: number;
  videoFolderOrder: number;
  enabled: boolean;
  startDate: string;
  endDate: string;
}
